import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TripService } from '../../providers/trip-service/trip-service';
import * as debug from 'debug';
import * as _ from 'lodash';

@Component({
  selector: 'place-icon',
  templateUrl: 'place-icon.html',
})
export class PlaceIconComponent {
  log = debug('app:PlaceIconComponent');

  @Input()
  place: any = {};

  @Input()
  stifleToggleEvent = false;

  @Input()
  useActiveOverride = false;

  @Input()
  genericPlaceTitle = false;

  @Input()
  activeOverride = false;
  @Input() showTitle = true;
  @Input() iconSize = 1;

  @Output()
  toggle = new EventEmitter();

  @Output()
  tapped = new EventEmitter();

  constructor(public tripService: TripService) {
    this.log('constructed');
  }

  toggleActive() {
    event.stopPropagation();

    this.log('place', this.place);

    if (this.useActiveOverride) {
      this.tapped.emit();
    } else {
      this.place.isActive = !this.place.isActive;

      if (!this.stifleToggleEvent) {
        this.tripService.emit('togglePlaceType', this.place);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/place-icon/place-icon.ts